module.exports = __webpack_public_path__ + "img/2.03833048.jpg";